import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notifyEmployees, getMessages } from '../../actions/alert_actions';
const $ = window.$;

class Modal extends React.Component {
  componentDidMount() {
    $(`#${this.props.id}`).modal();
  }
  getMobileEmployees() {
    //get employees with mobile phone
    let mobile = this.props.employees.filter((emp) => emp.mobilePhone);
    return mobile.map((emp, i) => <li key={i.toString()} className="collection-item">{emp.FirstName} {emp.LastName}</li>)
  }

  getLandlineEmployees() {
    //get employees with landline phone
    let mobile = this.props.employees.filter((emp) => emp.phone);
    return mobile.map((emp, i) => <li key={i.toString()} className="collection-item">{emp.FirstName} {emp.LastName}</li>)
  }

  render() {
    let d = new Date().toLocaleDateString("en-US");
    let combinedMessage = this.props.prefillMessage + " " + this.props.optionalMessage;

    return(
      <div id={this.props.id} className="modal">
        <div className="modal-content">
          <h5>Confirm Message</h5>
          <table>
            <tbody className="modalTable">
              <tr>
                <td>Date</td>
                <td>{d}</td>
              </tr>
              <tr>
                <td>Location</td>
                <td>Location: {this.props.location} - Gang No. {this.props.gang}</td>
              </tr>
              <tr>
                <td>Message</td>
                <td>{combinedMessage}</td>
              </tr>
            </tbody>
          </table>
          <div className="col m6 s12">
            <h6>Employees To Be Texted</h6>
            <ul className="collection modal-list">
              {this.getMobileEmployees()}
            </ul>
          </div>
          <div className="col m6 s12">
            <h6>Employees To Be Called</h6>
            <ul className="collection modal-list">
              {this.getLandlineEmployees()}
            </ul>
          </div>
          <a className="modal-close btn-flat">Cancel</a>
          <button onClick={() => {this.props.notifyEmployees(this.props.location, this.props.gang, combinedMessage, this.props.eid);}} className="btn modal-close">Confirm</button>
          <br/>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    location: state.form.location,
    gang: state.form.gang,
    employees: state.list.employees,
    prefillMessage: state.form.prefillMessage,
    optionalMessage: state.form.optionalMessage,
    eid: state.auth.user.guid
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    notifyEmployees,
    getMessages
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/components/alert/modal.js